import React from 'react';
import { TB_PORTAL_SCHOOL_DETAILS_ROUTE } from '../../../routes/routes';
import moment from 'moment';
import { Link } from 'react-router-dom/cjs/react-router-dom';

export const userColumn = [
  { Header: 'School name', accessor: 'name' },
  {
    Header: 'User email',
    accessor: '',
    Cell: (val) => {
      const payload = val.cell.row.original;
      return (
        <p>
          {payload &&
            payload.schoolAdmins &&
            payload.schoolAdmins[0] &&
            payload.schoolAdmins[0].email}
        </p>
      );
    },
  },
  { Header: 'School email', accessor: 'email' },
  { Header: 'Phone', accessor: 'phone' },
  {
    Header: 'Status',
    accessor: '',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const { isActive } = payload;

      return <div>{isActive === true ? 'Active' : 'Inactive'}</div>;
    },
  },
  {
    Header: 'Expiry date',
    accessor: '',
    Cell: (val) => {
      return (
        <p>{moment(val.cell.row.original.expiryDate).format('DD MMM YYYY')}</p>
      );
    },
  },
  {
    Header: 'Action',
    accessor: '_id',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const { _id } = payload;

      return (
        <Link
          style={{ textDecoration: 'none', color: 'black' }}
          to={`${TB_PORTAL_SCHOOL_DETAILS_ROUTE}?schoolId=${_id}`}>
          View details
        </Link>
      );
    },
  },
];
